import { Component, ViewChild } from '@angular/core';
import { NavController, LoadingController, NavParams, ModalController } from 'ionic-angular';
import { Globals } from "../../../../../globals";
import { DishServices } from "../../../../dish/services";
import { IngredientsServices } from "../../../../ingredients/services";
import { ProductsServices } from "../../../../products/services";
import { ConfigurationVariationsCreateInfoPage } from "../configuration-variations-create-info/configuration-variations-create-info";
import { TranslateService } from '@ngx-translate/core';
import { ConfigurationServices } from '../../../services';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { CompCreateIngredientPage } from '../../../../components/popups/create-ingredient/create-ingredient';
import { CompCreateDishPage } from '../../../../components/popups/create-dish/create-dish';
import { CompCreateProductPage } from '../../../../components/popups/create-product/create-product';

@Component({
    selector: 'page-configuration-variation-create-list',
    templateUrl: 'configuration-variation-create-list.html'
})

export class ConfigurationVariationCreateListPage {

    type: any;
    //datatable
    sorts = [
        { prop: 'name', dir: 'asc' }
    ];
    @ViewChild(DatatableComponent) table: DatatableComponent;
    ColumnMode = ColumnMode;
    config_msg = {
        emptyMessage: this.translate.instant('general-no-hay-datos'),
        totalMessage: this.translate.instant('general-total'),
        selectedMessage: this.translate.instant('general-seleccionado')
    };

    constructor(public navCtrl: NavController,
        public globals: Globals,
        public dishServices: DishServices,
        public ingredientsServices: IngredientsServices,
        public productsServices: ProductsServices,
        public loadingCtrl: LoadingController,
        public navParams: NavParams,
        public translate: TranslateService,
        public configurationServices: ConfigurationServices,
        public modalCtrl: ModalController) {

        let loadingPopup = this.loadingCtrl.create({
            spinner: 'crescent',
            content: this.translate.instant('instant-cargando-variaciones')
        });
        loadingPopup.present();
        this.type = this.navParams.get('type');
        if (this.type == 'dish') {
            //this.dishServices.getListDishesVariations(this.globals.restaurant_uid);
            this.dishServices.getPagesDishes(50);
        } else if (this.type == 'ingredient') {
            //this.ingredientsServices.getListIngredientsVariations(this.globals.restaurant_uid);
            this.ingredientsServices.getPagesIngredients('all', 50);
        } else if (this.type == 'product') {
            //this.productsServices.getListProductsVariations(this.globals.restaurant_uid);
            this.productsServices.getPagesProducts('all', 50);
        } else if (this.type == 'all') {
            this.configurationServices.getDishesProductsIngredients();
        }
        loadingPopup.dismiss();
    }

    openDishForm(dish) {
        this.GA(dish.name_es);
        this.navCtrl.push(ConfigurationVariationsCreateInfoPage, {
            dish: dish,
            type: 'dish',
        });
    }

    openIngredientForm(ingredient) {
        this.GA(ingredient.name);
        this.navCtrl.push(ConfigurationVariationsCreateInfoPage, {
            ingredient: ingredient,
            type: 'ingredient',
        });
    }

    openProductForm(product) {
        this.GA(product.name);
        this.navCtrl.push(ConfigurationVariationsCreateInfoPage, {
            product: product,
            type: 'product',
        });
    }

    GA(element) {
        this.globals.GAtrackView('Configuration', 'Configuration - Variation - Select element - Create ', this.globals.restaurant.email, 'Create/Update', 'Create variation select element', 'Configuration', element);
    }

    searchDishNode(value) {
        this.dishServices.searchDishNode(value);
    }
    searchIngredientNode(value, type) {
        this.ingredientsServices.searchIngredientNode(value, type);
    }
    searchProductNode(value, type) {
        this.productsServices.searchProductNode(value, type);
    }
    nextPage() {
        if (this.type == 'dish') {
            if (this.dishServices.page_active < this.dishServices.pagesDishes.length) {
                this.dishServices.page_active += 1
            }
            this.dishServices.getListDishesAllMinMax();
        } else if (this.type == 'ingredient') {
            if (this.ingredientsServices.page_active < this.ingredientsServices.pagesIngredients.length) {
                this.ingredientsServices.page_active += 1
            }
            this.ingredientsServices.getListIngredientsMinMax();
        } else {
            if (this.productsServices.page_active < this.productsServices.pagesProducts.length) {
                this.productsServices.page_active += 1
            }
            this.productsServices.getListProductsMinMax();
        }
    }
    previusPage() {
        if (this.type == 'dish') {
            if (this.dishServices.page_active > 1) {
                this.dishServices.page_active -= 1;
            }
            this.dishServices.getListDishesAllMinMax();
        } else if (this.type == 'ingredient') {
            if (this.ingredientsServices.page_active > 1) {
                this.ingredientsServices.page_active -= 1;
            }
            this.ingredientsServices.getListIngredientsMinMax();
        } else {
            if (this.productsServices.page_active > 1) {
                this.productsServices.page_active -= 1;
            }
            this.productsServices.getListProductsMinMax();
        }
    }
    activePage(number) {
        if (this.type == 'dish') {
            this.dishServices.page_active = number;
            this.dishServices.getListDishesAllMinMax();
        } else if (this.type == 'ingredient') {
            this.ingredientsServices.page_active = number;
            this.ingredientsServices.getListIngredientsMinMax();
        } else {
            this.productsServices.page_active = number;
            this.productsServices.getListProductsMinMax();
        }

    }

    clickElement(event) {
        if (event.type == 'click') {
            if (event.row.type == 'dish') {
                this.openDishForm(event.row);
            } else if (event.row.type == 'product') {
                this.openProductForm(event.row);
            } else {
                this.openIngredientForm(event.row);
            }
        }
    }

    searchElements(value) {
        if (value) {
            this.configurationServices.list_dishes_products_ingredients_filtered = this.configurationServices.list_dishes_products_ingredients.filter(objeto => {
                return this.globals.objectToArray(objeto).some(valor => {
                    if (typeof valor === 'string' || typeof valor === 'number') {
                        // Comparar como string
                        return valor.toString().toLowerCase().includes(value.toLowerCase());
                    } else if (Array.isArray(valor)) {
                        // Buscar en cada elemento del array
                        return valor.some(elemento => elemento.toString().toLowerCase().includes(value.toLowerCase()));
                    }
                    return false;
                });
            });
        } else {
            this.configurationServices.list_dishes_products_ingredients_filtered = this.configurationServices.list_dishes_products_ingredients;
        }
    }

    openCreateIngredient() {
        let profileModal = this.modalCtrl.create(CompCreateIngredientPage, {
            origin: 'variations'
        });
        profileModal.onDidDismiss(data => {
            if (data) {
                this.configurationServices.getDishesProductsIngredients();
                this.openIngredientForm(data);
            }
        });
        profileModal.present();
    }

    openCreateArticleBasic() {
        let profileModal = this.modalCtrl.create(CompCreateProductPage, {
            origin: 'variations'
        });
        profileModal.onDidDismiss(data => {
            if (data) {
                this.configurationServices.getDishesProductsIngredients();
                this.openProductForm(data);
            }
        });
        profileModal.present();
    }

    openCreateArticleFoodcost() {
        let profileModal = this.modalCtrl.create(CompCreateDishPage, {
            origin: 'variations'
        });
        profileModal.onDidDismiss(data => {
            if (data) {
                this.configurationServices.getDishesProductsIngredients();
                this.openDishForm(data);
            }
        });
        profileModal.present();
    }

    onSort(event) {
        var list_array = this.configurationServices.list_dishes_products_ingredients_filtered;

        switch (event.column.name) {
            case 'name':
                if (event.newValue == 'asc') {
                    list_array.sort((a, b) => this.globals.nameLangSelectIngredient(a).localeCompare(this.globals.nameLangSelectIngredient(b)));
                } else {
                    list_array.sort((a, b) => this.globals.nameLangSelectIngredient(b).localeCompare(this.globals.nameLangSelectIngredient(a)));
                }
                break;
        }

        this.configurationServices.list_dishes_products_ingredients_filtered = list_array;
    }

}


// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-variations/configuration-variations-create/configuration-variation-create-list/configuration-variation-create-list.ts